import type { FC } from 'react';

import { useInsightsTracking } from '@xing-com/crate-insights-tracking';
import { CarouselSection } from '@xing-com/crate-x4e-carousel-section';
import { ContentCard } from '@xing-com/crate-x4e-content-card';

import type { InsightsArticleFragment } from '../../graphql/insights-article.fragment.gql-types';

export const HeroCarouselSection: FC<{
  articles?: InsightsArticleFragment[];
}> = ({ articles }) => {
  const { trackWithNWT } = useInsightsTracking();

  const filteredArticles = articles?.filter((article) => {
    const { details } = article;
    return Boolean(details?.title) || Boolean(details?.image);
  });

  return (filteredArticles?.length ?? 0) > 0 ? (
    <CarouselSection
      titleKey="INSIGHTS_LO_HERO_SECTION_TITLE"
      subtitleKey="INSIGHTS_LO_HERO_SECTION_SUBTITLE"
      markerKey="INSIGHTS_LO_HERO_SECTION_MARKER"
      variant="hero"
    >
      {filteredArticles?.map((props, index) => {
        const { objectUrn, category, details } = props ?? {};
        const { url } = details ?? {};
        const trackedUrl = `${url}?sc_o=insights_popular_articles_module_${category?.toLowerCase()}_click&sc_o_PropActionOrigin=discover_update_InsightsPopularArticlesModule`;

        const trackArticle = (e?: MouseEvent): void =>
          trackWithNWT({
            event: e ? 'opened' : 'entered_viewport',
            element: 'popular_article',
            element_detail: category?.toLowerCase(),
            itemUrn: objectUrn ?? '',
            moduleTitle: 'discover_insights_popular_articles',
            position: index + 1,
            verticalPosition: 1,
            modulePosition: 1,
            positionInModule: index + 1,
          });

        return (
          <ContentCard
            variant="hero"
            key={objectUrn}
            to={trackedUrl}
            // @ts-expect-error FIXME: SC6
            onClick={trackArticle}
            onEnter={trackArticle}
            {...props}
            {...details}
          />
        );
      })}
    </CarouselSection>
  ) : null;
};
